// src/utils/buildSearchParamsString.js

/**
 * Converts the Next.js 14 `searchParams` object (Server Component prop) into a
 * query string compatible with `QueryStringManager` (spec §7.2, fix CR-02).
 *
 * `searchParams` values may be `string`, `string[]` or `undefined`.
 *
 * @param {Record<string, string | string[] | undefined>} [searchParams]
 * @returns {string} a query string with a leading `?` (or '' when empty)
 *
 * @example
 * buildSearchParamsString({ ets_cmmk: 'X', tags: ['a', 'b'] })
 * // '?ets_cmmk=X&tags=a&tags=b'
 */
export function buildSearchParamsString(searchParams) {
  if (!searchParams || typeof searchParams !== 'object') return ''

  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(searchParams)) {
    if (value === undefined || value === null) continue

    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== undefined && entry !== null) {
          params.append(key, String(entry))
        }
      })
    } else {
      params.set(key, String(value))
    }
  }

  const queryString = params.toString()
  return queryString ? `?${queryString}` : ''
}

export default buildSearchParamsString
